export default "__VITE_ASSET__CrSABUhw__"